import React, { useState } from 'react';
import {
  Group,
  Icon,
  Input as InputChakra,
  InputElement,
  InputProps,
} from '@chakra-ui/react';
import { ReactComponent as SearchIcon } from 'assets/icons/magnifying-glass.svg';

const Search = React.forwardRef<HTMLInputElement, InputProps>(
  ({ ...rest }, forwardedRef) => {
    const ref = React.useRef<HTMLInputElement>(null);
    const [filled, setFilled] = useState<boolean>(false);
    return (
      <Group attached ref={ref} position="relative" w="full">
        <InputChakra
          placeholder="Search"
          height="10"
          w="full"
          border="1px solid"
          borderColor="body2"
          borderRadius="lg"
          background="dark"
          color="secondary2"
          fontSize="md"
          onKeyDown={() => setFilled(true)}
          onFocus={() => setFilled(false)}
          _placeholder={{ color: 'body2' }}
          _focus={{
            borderColor: 'lightPrimary',
          }}
          ref={forwardedRef}
          {...rest}
        />
        <InputElement placement="end" pr={2}>
          <Icon
            as={SearchIcon}
            h="10"
            w="10"
            borderColor="body2"
            stroke={filled ? 'body' : 'body2'}
          />
        </InputElement>
      </Group>
    );
  }
);

Search.displayName = 'Search';
export default Search;
